import React from "react";
import { Input } from "@chakra-ui/react";

import { InputProps } from "../../utils/types/props.input";
import FormInputWrapper from "../form-input-wrapper/";

const FormInput = ({
  type,
  label,
  placeholder,
  isRequired,
  ref,
  icon,
  errorMessage,
  margin,
  multiple,
  value,
  height,
  disabled,
  onChange,
}: InputProps) => {
  return (
    <FormInputWrapper
      label={label}
      isRequired={isRequired}
      icon={icon}
      errorMessage={errorMessage as string}
      margin={margin}
    >
      <Input
        as={Input}
        multiple={multiple}
        height={height}
        id={label}
        errorBorderColor="red.300"
        borderWidth={1}
        borderColor={"gray.200"}
        name={label}
        disabled={disabled}
        type={type}
        placeholder={placeholder}
        ref={ref}
        onChange={onChange}
        mt={0}
        value={value}
      />
    </FormInputWrapper>
  );
};

export default FormInput;
